import React from 'react';
import './Testimonials.css';
import { useTranslation } from '../../i18n/TranslationContext';

interface TestimonialType {
  id: number;
  name: string;
  location: string;
  text: string;
  rating: number;
  role?: string;
}

const testimonials: TestimonialType[] = [
  {
    id: 1,
    name: 'Pierre Tremblay',
    location: 'Québec, QC',
    role: 'Propriétaire',
    text: "Service exceptionnel! L'équipe a fait un travail remarquable pour notre projet de terrassement.",
    rating: 5
  },
  {
    id: 2,
    name: 'Marie-Claude Gagnon',
    location: 'Lévis, QC',
    role: 'Entrepreneur',
    text: 'Très satisfaite du travail effectué. Le nivellement de notre terrain était parfait pour notre piscine.',
    rating: 5
  },
  {
    id: 3,
    name: 'Jean-François Bélanger',
    location: 'Beauport, QC',
    role: 'Gérant de projet',
    text: 'Entreprise fiable et compétente. Ils ont su répondre à nos besoins spécifiques pour notre projet.',
    rating: 4
  },
  {
    id: 4,
    name: 'Sophie Dubois',
    location: 'Charlesbourg, QC',
    role: 'Architecte paysagiste',
    text: 'Service à la clientèle exceptionnel et travail de qualité. Je recommande fortement Vaudreuil Multiservices!',
    rating: 5
  }
];

const Testimonials: React.FC = () => {
  const { t } = useTranslation();

  const renderStars = (rating: number) => {
    return Array(5).fill(0).map((_, index) => (
      <i 
        key={index} 
        className={`fas fa-star${index < rating ? ' active' : ''}`}
      ></i>
    ));
  };

  return (
    <section id="testimonials" className="testimonials-section">
      <div className="testimonials-glow"></div>
      <div className="container">
        <h2 className="section-title">{t.testimonials.title}</h2>
        
        <div className="testimonial-grid">
          {testimonials.map((testimonial) => (
            <div key={testimonial.id} className="testimonial-card glass-panel">
              <div className="testimonial-header">
                <div className="testimonial-meta">
                  <h4>{testimonial.name}</h4>
                  <div className="testimonial-info">
                    <span className="testimonial-location">
                      <i className="fas fa-map-marker-alt"></i>
                      {testimonial.location}
                    </span>
                    {testimonial.role && (
                      <span className="testimonial-role">
                        <i className="fas fa-briefcase"></i>
                        {testimonial.role}
                      </span>
                    )}
                  </div>
                </div>
                <div className="quote-icon">
                  <i className="fas fa-quote-right"></i>
                </div>
              </div>
              
              <div className="testimonial-body">
                <p>{testimonial.text}</p>
              </div>
              
              <div className="testimonial-footer">
                <div className="testimonial-rating">
                  {renderStars(testimonial.rating)}
                </div>
                <div className="testimonial-date">
                  <i className="far fa-calendar-alt"></i>
                  <span>{t.testimonials.verified}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
        

      </div>
    </section>
  );
};

export default Testimonials;